import { Component, Input } from '@angular/core';
import { BaseClient, ClientType } from '@models/clients';
import { Select } from '@ngxs/store';
import { ClientsState } from '@state/clients';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
	selector: 'app-edit-client',
	templateUrl: './edit-client.component.html',
	standalone: false,
})
export class EditClientComponent {
	@Input() id: string;
	@Select(ClientsState.getClient) clientFilter$: Observable<
		(filter: string) => BaseClient
	>;

	public clientTypes = ClientType;

	get client$() {
		return this.clientFilter$.pipe(
			untilDestroyed(this),
			map((filterFn) => filterFn(this.id)),
		);
	}
}
